export default function startOfficeOnline(
    accessToken: string,
    accessTokenTTL: number,
    actionUrl: string,
    frameholder: HTMLElement,
    addinsJson: string
) {
    if (!frameholder) {
        throw "No element to put the office online frame in.";
    }

    let office_frame: HTMLIFrameElement = <HTMLIFrameElement>document.getElementById("office_online_frame");
    if (!office_frame) {
        office_frame = document.createElement("iframe");
    }

    //generate the office frame
    //Set name and id to office_frame so it can be used in css
    office_frame.name = "office_online_frame";
    office_frame.id = "office_online_frame";
    // The title should be set for accessibility
    office_frame.title = "Office Online Frame";
    //set style
    office_frame.style.width = "100%";
    office_frame.style.height = "100%";
    office_frame.style.position = "absolute";
    office_frame.style.top = "0";
    office_frame.style.left = "0";
    office_frame.style.right = "0";
    office_frame.style.bottom = "0";
    office_frame.style.border = "none";
    office_frame.style.display = "block";
    // This attribute allows true fullscreen mode in slideshow view
    // when using PowerPoint Online's 'view' action.
    office_frame.setAttribute("allowfullscreen", "true");

    office_frame.sandbox?.add(
        "allow-scripts",
        "allow-same-origin",
        "allow-forms",
        "allow-popups",
        "allow-top-navigation",
        "allow-popups-to-escape-sandbox",
        "allow-downloads"
    );

    //create form data to send for the office application
    let form: HTMLFormElement = document.createElement("form");
    let accessTokenFormInput: HTMLInputElement = document.createElement("input");
    let accessTokenTtlFormInput: HTMLInputElement = document.createElement("input");
    document.body.appendChild(form);
    form.appendChild(accessTokenFormInput);
    form.appendChild(accessTokenTtlFormInput);
    form.name = "office_online_form";
    form.target = office_frame.name;
    form.method = "POST";
    form.action = actionUrl;
    accessTokenFormInput.id = "access_token_form";
    accessTokenFormInput.name = "access_token";
    accessTokenFormInput.type = "hidden";
    accessTokenFormInput.value = accessToken;
    accessTokenTtlFormInput.id = "access_token_ttl_form";
    accessTokenTtlFormInput.name = "access_token_ttl";
    accessTokenTtlFormInput.type = "hidden";
    accessTokenTtlFormInput.value = accessTokenTTL.toString();

    if (addinsJson) {
        let hostInstallAddinsFormInput: HTMLInputElement = document.createElement("input");
        hostInstallAddinsFormInput.id = "host_install_addins_form";
        hostInstallAddinsFormInput.name = "host_install_addins";
        hostInstallAddinsFormInput.type = "hidden";
        hostInstallAddinsFormInput.value = addinsJson;
        form.appendChild(hostInstallAddinsFormInput);
    }

    frameholder.appendChild(office_frame);
    form.submit();

    document.body.removeChild(form);
}

(window as any).handleOfficeOnlinePostMessage = function (e) {
    // The actual message is contained in the data property of the event.
    let receivedMsg = JSON.parse(e.data);
    let OfficeWebAppUrl = "";

    if (receivedMsg.MessageId == "App_IsFrameTrusted") {
        const msg = {
            MessageId: "Host_IsFrameTrusted",
            SendTime: Date.now(),
            Values: { isTopFrameTrusted: true } //true if you have checked your page is top frame //or your page can only be iframed by trusted pages and it is protected by header such //as X-Frame-Options.
        };
        e.source.postMessage(JSON.stringify(msg), e.origin);
    }
};
